import {useQuery} from '@tanstack/react-query';

/**
 * useLoadLangs hook — fetches translations for the given language.
 * Called inside AppContextProvider. React Query key includes lang so
 * translations automatically refetch when language changes.
 * @param {string} loadLang - language code to load ('sk' | 'en')
 * @returns {void}
 */
export default function useLoadLangs(loadLang: string = 'sk') {
    /**
     * queryData - fetch translations from API
     * @returns {Promise}
     */
    const queryLang = async () => {
        const effectiveLanguage = loadLang || 'sk';
        const response = await this.fetch(`lang/get/${effectiveLanguage}`);
        return response;
    };

    this.lang = useQuery({queryKey: ['lang', loadLang], queryFn: queryLang});

    if (this.lang.isError && !this.lang.isLoading) {
        console.error('useLoadLangs >> lang is unable to load', this.lang);
        throw new Error(this.lang.error.message);
    }
}
